// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1esCG","type":"styles_type__4FOLb","choices":"styles_choices__3R5e-"};